const setRPDummy = {
  statusCode: 200,
  jsonResult: {
    granted: false,
    reason: "UNDER",
  },
};

export default setRPDummy;
